// Single source of truth for the corridors Abood Bus actually operates.
// Consumed by:
//   - HeroSection's "Popular routes" strip (slices the top N popular)
//   - RoutesNetworkSection (full grid + filter + mini network map)
//
// Each entry MUST reference city names that exist in
// `src/data/tanzaniaCities.js` (the lat/lng table). The mini map
// looks them up by name to draw the route arcs.
//
// Source for the corridor list: operator-supplied 2026 spreadsheet
// (22 lines, mostly Dar-originating long-hauls). Duration / dailyTrips
// / fromPrice are operator estimates and should be refreshed from the
// real schedules table when v2 search wiring is live.
export const ABOOD_ROUTES = [
  // ── Dar es Salaam (main hub) ─────────────────────────────────────
  { from: "Dar es Salaam", to: "Morogoro",      durationHrs:  3, dailyTrips: 12, fromPrice: 12000, popular: true  },
  { from: "Dar es Salaam", to: "Tanga",         durationHrs:  6, dailyTrips:  4, fromPrice: 22000, popular: true  },
  { from: "Dar es Salaam", to: "Moshi",         durationHrs:  8, dailyTrips:  5, fromPrice: 38000, popular: true  },
  { from: "Dar es Salaam", to: "Arusha",        durationHrs:  9, dailyTrips:  6, fromPrice: 40000, popular: true  },
  { from: "Dar es Salaam", to: "Iringa",        durationHrs:  9, dailyTrips:  3, fromPrice: 35000                  },
  { from: "Dar es Salaam", to: "Singida",       durationHrs: 10, dailyTrips:  2, fromPrice: 38000                  },
  { from: "Dar es Salaam", to: "Mombasa",       durationHrs: 10, dailyTrips:  1, fromPrice: 55000                  },
  { from: "Dar es Salaam", to: "Lindi",         durationHrs: 12, dailyTrips:  2, fromPrice: 45000                  },
  { from: "Dar es Salaam", to: "Mbeya",         durationHrs: 13, dailyTrips:  3, fromPrice: 55000, popular: true  },
  { from: "Dar es Salaam", to: "Mtwara",        durationHrs: 14, dailyTrips:  2, fromPrice: 50000                  },
  { from: "Dar es Salaam", to: "Tunduma",       durationHrs: 16, dailyTrips:  2, fromPrice: 65000                  },
  { from: "Dar es Salaam", to: "Tabora",        durationHrs: 16, dailyTrips:  2, fromPrice: 60000                  },
  { from: "Dar es Salaam", to: "Kahama",        durationHrs: 18, dailyTrips:  2, fromPrice: 65000                  },
  { from: "Dar es Salaam", to: "Shinyanga",     durationHrs: 18, dailyTrips:  2, fromPrice: 65000                  },
  { from: "Dar es Salaam", to: "Mwanza",        durationHrs: 18, dailyTrips:  4, fromPrice: 60000, popular: true  },
  { from: "Dar es Salaam", to: "Musoma",        durationHrs: 22, dailyTrips:  1, fromPrice: 70000                  },
  { from: "Dar es Salaam", to: "Tarime",        durationHrs: 22, dailyTrips:  1, fromPrice: 72000                  },
  { from: "Dar es Salaam", to: "Bukoba",        durationHrs: 22, dailyTrips:  2, fromPrice: 75000                  },
  { from: "Dar es Salaam", to: "Karagwe",       durationHrs: 24, dailyTrips:  1, fromPrice: 80000                  },
  { from: "Dar es Salaam", to: "Kigoma",        durationHrs: 28, dailyTrips:  1, fromPrice: 85000                  },

  // ── Morogoro (secondary origin) ──────────────────────────────────
  { from: "Morogoro",      to: "Moshi",         durationHrs:  5, dailyTrips:  2, fromPrice: 32000                  },
  { from: "Morogoro",      to: "Arusha",        durationHrs:  6, dailyTrips:  2, fromPrice: 35000                  },
];

/**
 * Origin cities Abood departs from. Drives the filter chip rail at
 * the top of RoutesNetworkSection.
 */
export const HUB_ORIGINS = ["Dar es Salaam", "Morogoro"];

/**
 * The top N "popular" routes — used by the hero's compact strip.
 * Anything tagged `popular: true` above. Order preserved as listed.
 */
export function popularRoutes(n = 6) {
  return ABOOD_ROUTES.filter((r) => r.popular).slice(0, n);
}
